import angular from 'angular';
import { IStateProvider, IUrlRouterProvider } from 'angular-ui-router';
import { STATE_MAPPINGS } from '@Shared.Angular/@types/stateMappings';

angular.module('flowingly.runner.processmapsv2').config(config);

config.$inject = ['$stateProvider', '$urlRouterProvider'];

function config(
  $stateProvider: IStateProvider,
  $urlRouterProvider: IUrlRouterProvider
) {
  $stateProvider
    .state(STATE_MAPPINGS.processmapsv2, {
      url: 'processmaps',
      params: {
        title: 'Process Maps',
        backFromState: ''
      },
      controller: 'runnerProcessMapsV2Controller',
      controllerAs: '$ctrl',
      templateUrl: 'Client/runner.processmapsv2/runner.processmapsv2.tmpl.html'
    })
    .state(STATE_MAPPINGS.processmapviewv2, {
      url: 'processmaps/:processMapId',
      params: {
        title: 'Process Maps',
        backFromState: ''
      },
      templateUrl:
        'Client/runner.processmapsv2/view/runner.processmapsv2.view.tmpl.html',
      controller: 'runnerProcessMapsV2ViewController',
      controllerAs: '$ctrl'
    });

  $urlRouterProvider.when('/processmapsv2', '/processmaps');
  $urlRouterProvider.when(
    '/processmapsv2/:processMapId',
    '/processmaps/:processMapId'
  );
}
